import styled from 'styled-components';
import colors from '../../../config/colors';

const ErrorMessage = styled.div`
  color: ${colors.ERROR_RED};
  font-family: "Gilroy-Medium";
  font-size: 14px;
  padding-left: 14px;
  margin-bottom: 15px;
`;

export default ErrorMessage;
